module.exports = __webpack_public_path__ + "static/media/whole-article-image3.6ea2d557.jpg";